import { render, staticRenderFns } from "./DocumentationUpload.vue?vue&type=template&id=4bc69fb6&scoped=true"
import script from "./DocumentationUpload.vue?vue&type=script&lang=js"
export * from "./DocumentationUpload.vue?vue&type=script&lang=js"
import style0 from "./DocumentationUpload.vue?vue&type=style&index=0&id=4bc69fb6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc69fb6",
  null
  
)

export default component.exports